export const getVerification = state => state.verification;
export const getProgress = state => state.verification.progress;
export const getVerificationState = state => state.verification.state;
export const getVerificationErrors = state => state.verification.errors;
export const getLabels = state => state.verification.labels;
export const isPreprocessRunning = state => state.verification.preprocessRunning;
